import styled from 'styled-components'
import colors from '../../tokens/colors'
import border from '../../tokens/border'
import layout from '../../tokens/layout'
import { composeTheme } from '../../utils/compose-theme'

export const SideMenu = styled.div.attrs((props) => composeTheme(props))`
  background-color: ${(props) =>
    props.theme.brandColors?.sideMenuBackgroundColor
      ? props.theme.brandColors.sideMenuBackgroundColor
      : colors.neutralColorHighPure};
  border-right: ${border.width.widthHairline} solid
    ${(props) =>
      props.theme.brandColors?.sideMenuDividerColor
        ? props.theme.brandColors.sideMenuDividerColor
        : colors.neutralColorLowLight};
  display: inline-block;
  padding-top: ${layout.padding.spacingInsetLg};
  width: ${(props) => (props.theme.collapsed ? 'auto' : '26rem')};
`

export const Container = styled.section`
  display: inline-block;
  position: relative;
`
type contentWrapperProps = {
  position: number
}

export const ContentWrapper = styled.div.attrs((props) =>
  composeTheme(props),
)<contentWrapperProps>`
  height: calc(100% - 14rem);
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: ${(props) =>
      props.theme.brandColors?.sideMenuBackgroundColor
        ? props.theme.brandColors.sideMenuBackgroundColor
        : colors.neutralColorLowLight}
    transparent;
  &::-webkit-scrollbar {
    z-index: 999;
    width: 2rem;
    height: 2rem;
  }
  &::-webkit-scrollbar-track {
    background-color: ${(props) =>
      props.theme.brandColors?.sideMenuBackgroundColor
        ? props.theme.brandColors.sideMenuBackgroundColor
        : colors.neutralColorHighPure};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${colors.neutralColorLowMedium};
    border: ${border.width.widthHeavy} solid
      ${(props) =>
        props.theme.brandColors?.sideMenuBackgroundColor
          ? props.theme.brandColors.sideMenuBackgroundColor
          : colors.neutralColorHighPure};
    border-radius: ${border.radius.radiusMd};
    &:hover {
      background-color: ${colors.neutralColorLowDark};
    }
  }
  ${(props) =>
    props.position > 0 &&
    `border-top: ${border.width.widthHairline} solid ${
      props.theme.brandColors?.sideMenuDividerColor
        ? props.theme.brandColors.sideMenuDividerColor
        : colors.neutralColorLowLight
    }`}
`
